import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import { SetParentCaseCommand } from './set-parent-case.command';
import { SetParentCaseResult } from './set-parent-case.result';

/**
 * Set parent case use case.
 * Links the current case as a child of another case.
 */
@Injectable({ providedIn: 'root' })
export class SetParentCaseUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  public execute(command: SetParentCaseCommand): Observable<SetParentCaseResult> {
    this._state.setErrorParentChildCases(null);

    return this._repository.setParentCase(command.caseId, command.parentCaseId).pipe(
      tap(() => {
        // Caller is responsible for reloading state after success
      }),
      map(() => ({ success: true })),
      catchError((error) => {
        this._state.setErrorParentChildCases(error.message || 'Failed to set parent case');
        return throwError(() => error);
      })
    );
  }
}
